import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../Contexts/AppContext";
import * as SiIcons from "react-icons/si";
import * as BsIcons from "react-icons/bs";
import * as FaIcons from "react-icons/fa";

const Services = () => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");

  useEffect(() => {
    setCurrentBG(
      context.isLight
        ? context.currentTheme["default"].bg
        : context.currentTheme["default"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["default"].text
        : context.currentTheme["default"].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme["default"].dark_dropdown
        : context.currentTheme["default"].dropdown
    );
  }, [context]);
  return (
    <div
      id="services"
      className="px-[5%] py-5 transition-all duration-500 xs:px-[10%]"
      style={{ backgroundColor: currentText, color: currentBG }}
    >
      <h1 className="mb-3 text-center text-3xl font-bold xs:mb-5 xs:text-4xl sm:text-left">
        Our Services
      </h1>
      <div className="flex flex-wrap items-start justify-center">
        <section
          className="m-2 flex h-auto w-[22rem] flex-col items-center rounded-lg p-5 pt-2 text-lg xs:h-80 xs:pt-5 sm:m-5"
          style={{
            backgroundColor: context.isLight ? currentColor : currentText,
          }}
        >
          <SiIcons.SiExpertsexchange
            className="rounded-full p-2 text-5xl"
            style={{ backgroundColor: currentBG, color: currentText }}
          />
          <h2 className="mt-2 mb-5 text-xl font-bold sm:mb-10 sm:text-2xl">
            UI/UX DESIGN
          </h2>
          <p>
            Make a good impression when you communicate your identity and the
            service to your audience.
          </p>
        </section>
        <section
          className="m-2 flex h-auto w-[22rem] flex-col items-center rounded-lg p-5 pt-2 text-lg xs:h-80 xs:pt-5 sm:m-5"
          style={{
            backgroundColor: context.isLight ? currentColor : currentText,
          }}
        >
          <BsIcons.BsStack
            className="rounded-full p-2 text-5xl"
            style={{ backgroundColor: currentBG, color: currentText }}
          />
          <h2 className="mt-2 mb-5 text-xl font-bold sm:mb-10 sm:text-2xl">
            GRAPHIC DESIGN
          </h2>
          <p>
            Get your custom and exceptional work of UI and UX web or app design,
            illustrations, and motion graphics for your needs.
          </p>
        </section>
        <section
          className="m-2 flex h-auto w-[22rem] flex-col items-center rounded-lg p-5 pt-2 text-lg xs:h-80 xs:pt-5 sm:m-5"
          style={{
            backgroundColor: context.isLight ? currentColor : currentText,
          }}
        >
          <FaIcons.FaDev
            className="rounded-full p-2 text-5xl"
            style={{ backgroundColor: currentBG, color: currentText }}
          />
          <h2 className="mt-2 mb-5 text-xl font-bold sm:mb-10 sm:text-2xl">
            DEVELOPMENT
          </h2>
          <p>
            Our expert Front-End Developers are ready to implement the aesthetic
            designs into codes using the latest technology.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Services;
